import moment from 'moment'
import "moment/locale/es";
const ExcelJS = require('exceljs');

export const consolidateCreditReport = async (data) => {

    let movements = []
    data.map(column => {
        column.FechaDePago = moment(column.FechaDePago).format("YYYY-MM-DD")
        column.FechaVencimiento = moment(column.FechaVencimiento).format("YYYY-MM-DD")
        movements.push(column)
        return column
    })

    const workbook = new ExcelJS.Workbook();
    workbook.addWorksheet("sheet1");
    const worksheet = workbook.getWorksheet("sheet1");

    const cabeceras = [
        'Fecha de pago',
        'Fecha de vencimiento',
        '# Cuota',
        'Capital',
        'Interes',
        'Comisión',
        'Seguro Desgravamen',
        'Total Cuota',
        'Saldo capital',
        'Tasa',
        'Estado',
    ];

    // worksheet.getCell('A2').value = 'Cliente'
    // worksheet.getCell('B2').value = `${user.customer.first_name} ${user.customer.surname}`
    // worksheet.getCell('A3').value = 'Fecha'
    // worksheet.getCell('B3').value = moment(dateStart).format('DD/MM/YYYY');

    worksheet.views = [
        { state: 'worksheet', zoomScale: 127, }
    ];

    const fuenteHoja = 'Calibri';

    const cabeceraColorHoja = '1C1B17';
    const tamanoContenido = 12;

    const rowHeader = worksheet.addRow(
        cabeceras
    );
    var borderStyle = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" }
    };

    var borderStyleHeader = {
        left: { style: "thin", color: { argb: 'ffffff' } },
        right: { style: "thin", color: { argb: 'ffffff' } }
    };

    rowHeader.eachCell((cell) => {
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: cabeceraColorHoja },
            bgColor: { argb: '' }
        };
        cell.font = {
            size: tamanoContenido,
            bold: true,
            color: { argb: 'ffffff' },
        };
        cell.alignment = {
            vertical: 'middle',
            horizontal: 'center'
        };
        cell.border = borderStyleHeader;
    });

    worksheet.columns = [
        { header: "", key: "FechaDePago" },
        { header: "", key: "FechaVencimiento" },
        { header: "", key: "NumeroCuota" },
        { header: "", key: "Capital" },
        { header: "", key: "Interes" },
        { header: "", key: "SeguroDesgravamen" },
        { header: "", key: "TotalCuota" },
        { header: "", key: "SaldoCapital" },
        { header: "", key: "Tasa" },
        { header: "", key: "Estado" },

    ];
    movements.forEach((value) => {
        worksheet.addRow(value).eachCell({ includeEmpty: true }, (cell, colNumber) => {
            cell.font = {
                name: fuenteHoja,
                size: tamanoContenido,
            };
            cell.border = borderStyle;
        })
    })

    const uint8Array = await workbook.xlsx.writeBuffer()

    const blob = new Blob([uint8Array], { type: "application/octet-binary" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Movimientos de Creditos.xlsx`;
    a.click();
    a.remove();
}